/**
 * Wrap a logger so that each level also routes through `window.alert`.
 *
 * Useful for debugging inside a WebView where no devtools are available.
 *
 * @param {{ error?: Function, warn?: Function, info?: Function, debug?: Function }} base
 */
export function wrapLoggerWithAlert(base) {
    const levels = ['error', 'warn', 'info', 'debug', 'log'];
    const canAlert = typeof window !== 'undefined' && typeof window.alert === 'function';
    const wrapped = {};

    for (const level of levels) {
        const original = base && typeof base[level] === 'function' ? base[level].bind(base) : null;
        wrapped[level] = function (...args) {
            if (original) {
                try { original(...args); } catch (_) { /* swallow */ }
            }
            if (!canAlert) return;
            try {
                const msg = args.map((a) => {
                    if (typeof a === 'string') return a;
                    try { return JSON.stringify(a); } catch (_) { return String(a); }
                }).join(' ');
                window.alert('[adxdb-bridge:' + level + '] ' + msg);
            } catch (_) { /* swallow */ }
        };
    }
    return wrapped;
}

/**
 * Default outbound transport: React Native WebView. Returns a bound
 * `postMessage` or `null` when no native host is reachable.
 */
export function defaultPostMessage() {
    if (typeof window === 'undefined') return null;
    const rn = /** @type {any} */ (window).ReactNativeWebView;
    if (!rn || typeof rn.postMessage !== 'function') return null;
    return rn.postMessage.bind(rn);
}
